module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-27.9d6c62d8.png";